import { Link } from "react-router-dom";
import { PackageCheck, ListChecks, PackagePlus, ClipboardCheck, Boxes, MapPin, ArrowRight, HeartHandshake } from "lucide-react";
import { PublicNav } from "@/components/PublicNav";

const VOL = "https://images.unsplash.com/photo-1599059813005-11265ba4b4ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHx2b2x1bnRlZXIlMjBmb29kJTIwZG9uYXRpb24lMjBjaGFyaXR5fGVufDB8fHx8MTc4MjkyMjAwOXww&ixlib=rb-4.1.0&q=85";

const features = [
  { icon: PackageCheck, title: "Claim grocery pickups", desc: "Get instant alerts when nearby stores post surplus food, and claim it in one tap." },
  { icon: ListChecks, title: "Post supply wishlists", desc: "List what you need beyond food — socks, blankets, hygiene kits — for donors to fund." },
  { icon: ClipboardCheck, title: "Approve requests", desc: "Review and approve requests from people in need before donors fulfill them." },
  { icon: Boxes, title: "Receive Amazon deliveries", desc: "Funded items ship directly to your organization for pickup and distribution." },
  { icon: PackagePlus, title: "Distribute & manage inventory", desc: "Track what's claimed, redistributed, and completed across your community." },
  { icon: MapPin, title: "Be found on the map", desc: "Appear on the public 'Find Help' map as a shelter, warming center, or pantry." },
];

export default function ForAidOrganizations() {
  return (
    <div className="min-h-screen bg-stone-50">
      <PublicNav />
      <section className="pt-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs tracking-widest uppercase text-orange-700 font-medium">For aid organizations</span>
            <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-stone-900 mt-4 leading-tight">
              You're the heart of the ecosystem.
            </h1>
            <p className="text-lg text-stone-600 mt-5 leading-relaxed">
              Gather connects your organization to surplus food from grocery stores, supplies funded by local donors,
              and requests from people who need help — all in one free place. No subscription, ever.
            </p>
            <Link data-testid="org-join-cta" to="/register?role=aid_organization" className="inline-flex items-center gap-2 bg-emerald-800 text-white rounded-full px-8 py-3.5 font-medium mt-8 hover:bg-emerald-900 transition-all hover:-translate-y-0.5">
              <HeartHandshake className="w-4 h-4" /> Join Gather — free
            </Link>
          </div>
          <img src={VOL} alt="Volunteers sorting donations" className="rounded-3xl w-full h-full object-cover min-h-[320px] shadow-sm" />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="bg-white rounded-2xl border border-stone-200 p-7 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all">
              <div className="w-11 h-11 rounded-xl bg-emerald-50 flex items-center justify-center"><f.icon className="w-5 h-5 text-emerald-800" /></div>
              <h3 className="font-heading text-lg font-medium text-stone-900 mt-5">{f.title}</h3>
              <p className="text-stone-600 mt-2 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link to="/register?role=aid_organization" className="inline-flex items-center gap-2 text-emerald-800 font-medium hover:underline">
            Get started <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
